import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocationStrategy } from '@angular/common';
import { WebsiteThemeService } from '../../../services/website-theme.service';
let InfoModalComponent = class InfoModalComponent {
    constructor(sanitizer, location, themeService) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.borderRadiusSmaller = '';
        this.errorColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        localStorage.setItem('wallet_info_modal_viewed', String(true));
    }
    close() {
        this.modal.destroy();
    }
};
InfoModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService }
];
InfoModalComponent = __decorate([
    Component({
        selector: 'ecd-wallet-info-modal',
        template: __importDefault(require("./info-modal.component.html")).default
    })
], InfoModalComponent);
export { InfoModalComponent };
